"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = exports.Id = exports.Type = exports.UserIdentifiers = exports.UserId = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../date");
exports.NAMESPACE = 'Culligan.Device.Session';
exports.UserId = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.UserId`,
});
exports.UserIdentifiers = effect_1.Schema.Struct({
    id: exports.UserId,
}).annotations({ identifier: `${exports.NAMESPACE}.UserIdentifiers` });
exports.Type = effect_1.Schema.Enums({
    Touchscreen: 0,
    App: 1,
    NFC: 2,
    Pass: 3,
    UWB: 4,
}).annotations({
    identifier: `${exports.NAMESPACE}.Type`,
});
exports.Id = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.Id`,
});
exports.Session = effect_1.Schema.Struct({
    id: exports.Id,
    type: exports.Type,
    startTime: date_1.ValidDateFromIso8601String,
    endTime: date_1.ValidDateFromIso8601String,
    user: effect_1.Schema.NullOr(exports.UserIdentifiers),
}).annotations({
    identifier: `${exports.NAMESPACE}.Session`,
});
//# sourceMappingURL=session.js.map